// extracted by mini-css-extract-plugin
export default {"hide":"Fieldset_hide__Ko6ph"};